import Modal from 'react-bootstrap/Modal';
import styles from "../../AdsPopup.module.scss";
import '../components/adsInfo.scss';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';
import deleteIcon from '../../../../assets/images/delete_forever.png';
import { useEffect, useRef, useState } from 'react';
import { toast, ToastContainer } from "react-toastify";
import editoutline from "../../../../assets/images/edit-outline.svg";
import customCss from "../components/adsInfo.scss";
import "../components/adsInfo.scss";
import closeIcon from "../../../../assets/svg/Assetmanagemant/closeIcon.svg";

const AdsInfo = ({
    show, 
    handleClose, 
    assetInfo, 
    millisecondsToHuman, 
    formatTime,
    appTheme, 
    categoryTab, 
    handlecategoryTab,
    permission,
    selectedFillers,
    fillerList,
    updateAdsTime,
    deleteAdEvent,
    adAdsOnClick,
    programDelete,
    toGetAssetInfo,
    updateProgramTime,
    verifyMilliSeconds,
    gridList,
    setPanelHoverTime,
    setPanelLinePosition,
    setPanelHoverDate,
    locationState,
    updateModalData,
    adValidate,
    setEditDisable,
    editDisable,
    promoList,
    editableTime
}) => {
    const [programInfo, setProgramInfo] = useState({});
    const tbodyRef = useRef(null);
    const assetInfoRef = useRef(programInfo);
    const ignoreClickRef = useRef(false);

    useEffect(() => {
            assetInfoRef.current = programInfo;
    }, [programInfo]);

    // useEffect(() => {
    //     const handleFocusOut = () => {
    //         setTimeout(() => {
    //             if (tbodyRef.current && !tbodyRef.current.contains(document.activeElement)) {
    //                 const sequence = assetInfoRef.current?.sequence;
    //                 if (sequence !== undefined) {
    //                     setShouldSort(sequence); // ✅ uses the latest sequence
    //                 }
    //             }
    //         }, 300);
    //     };

    //     const tbodyEl = tbodyRef.current;
    //     if (tbodyEl) {
    //         tbodyEl.addEventListener('focusout', handleFocusOut);
    //     }

    //     return () => {
    //         if (tbodyEl) {
    //             tbodyEl.removeEventListener('focusout', handleFocusOut);
    //         }
    //     };
    // }, []);

    useEffect(() => {
        const handleClick = (e) => {
            if (editDisable) return;
            if (ignoreClickRef.current) {
                ignoreClickRef.current = false;
                return;
            }
            if (tbodyRef.current) {
                if (!(tbodyRef.current.contains(e.target))) {
                    const sequence = assetInfoRef.current?.sequence;
                    if (sequence !== undefined) {
                        setShouldSort(sequence);
                    }
                }
            }
        };

        document.addEventListener("mousedown", handleClick);

        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, [editDisable]);

    useEffect(() => {
        setProgramInfo(assetInfo);
    },[assetInfo])

    const setShouldSort = (sequenceId) => {
        let sortedAdBreaks = assetInfoRef.current?.adBreaks || [];
        
        // let sortedAdBreaks = programInfo?.adBreaks
        //     .sort((a, b) => a.adInsertionPoint - b.adInsertionPoint)
        //     .map((ad, index) => ({ ...ad, adSqId: index + 1 }));

        const typePriority: Record<string, number> = {
            promo: 0,
            filler: 1,
        };

        // Sort & Reassign adSqId
        sortedAdBreaks = sortedAdBreaks
        .sort((a, b) => {
            if (a.adInsertionPoint !== b.adInsertionPoint) {
            return a.adInsertionPoint - b.adInsertionPoint;
            }
            const pa = typePriority[a.type] ?? 2;
            const pb = typePriority[b.type] ?? 2;
            return pa - pb;
        })
        .map((ad, index) => ({ ...ad, adSqId: index + 1 }));

        let totalDuration = 0;
        sortedAdBreaks = sortedAdBreaks.map((ad, index) => {
            if (index > 0) {
                totalDuration += sortedAdBreaks[index - 1]?.duration || 0;
            }
            const startOffsetInMillis = ad.adInsertionPoint + totalDuration;
    
            return {
                ...ad,
                startOffsetInMillis,
                startAt: millisecondsToHuman(startOffsetInMillis),
            };
        });

        let finalData = { ...programInfo, adBreaks: sortedAdBreaks }
        setProgramInfo(finalData);
    }

    const setProgramTime = (
        e, 
        programUuid, 
        sequenceId, 
        panelDate,
    ) => {
        let combinedTimeInMillis = panelDate + verifyMilliSeconds(e);
        let isOverlap = false;
        let updatedGridList = [...gridList];
        
        updatedGridList = updatedGridList.map((grid) => {
            let isGridEdited = false;
            const updatedScheduleItems = grid.scheduleItems.map((scheduleItem) => {
                if (scheduleItem.uuid === programUuid) {
                    const updatedStartAt = combinedTimeInMillis;
                    const updatedEndAt = updatedStartAt + scheduleItem.totalDuration;
    
                    // Check for overlap with other schedule items in the entire gridList
                    const isConflict = updatedGridList.some((grid) => {
                        return grid.scheduleItems.some((item) => {
                            if (item.uuid !== scheduleItem.uuid) {
                                return (
                                    (updatedStartAt > item.startAt && updatedStartAt < item.endAt) || // Starts within another program
                                    (updatedEndAt > item.startAt && updatedEndAt < item.endAt) ||   // Ends within another program
                                    (updatedStartAt < item.startAt && updatedEndAt > item.endAt)  // Envelops another program
                                );
                            }
                            return false;
                        });
                    });
    
                    if (isConflict) {
                        isOverlap = true;
                    }
    
                    isGridEdited = true;
    
                    return {
                        ...programInfo,
                        startAt: updatedStartAt,
                        endAt: updatedEndAt,
                    };
                }
                return scheduleItem;
            });
    
            return {
                ...grid,
                scheduleItems: updatedScheduleItems,
                isEdit: isGridEdited ? true : grid.isEdit
            };
        });
    
        // If overlap detected, show error and exit early
        if (isOverlap) {
            toast.error("Program cannot overlap with an existing program.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000,
            });
            setPanelHoverTime(null);
            setPanelLinePosition(null);
            setPanelHoverDate(null);
            return;
        }
    
        // Sort scheduleItems by startAt and update sequence numbers
        updatedGridList = updatedGridList.map((grid) => {
            const sortedScheduleItems = grid.scheduleItems.sort((a, b) => a.startAt - b.startAt);
            return {
                ...grid,
                scheduleItems: sortedScheduleItems.map((item, index) => ({
                    ...item,
                    sequence: index + 1,
                })),
            };
        });
        // Update state
        // setGridList(updatedGridList);
        const updatedMatchingSchedule = updatedGridList.find(
            item => item.date === panelDate
        );
        const matchedAsset = updatedMatchingSchedule?.scheduleItems.find(
            item => item.sequence === sequenceId
        );
        if (matchedAsset) {
            // setAssetInfo({ ...matchedAsset, panelDate: panelDate });
            setProgramInfo({ ...matchedAsset, panelDate: panelDate });
        }
    }
    
    const selectedFiller = (id, adSqId, sequenceId, panelDate, adType) => {
        
        let matchedFiller = [];
        if (adType == "filler") {
            matchedFiller = fillerList?.find(item => item.id === Number(id));
        } else if (adType == "promo") {
            matchedFiller = promoList?.find(item => item.id === Number(id));
        }

        let isGridEdited = false; 
        let updatedProgramInfo = { ...programInfo }; // Object ka clone banao
    
        if (updatedProgramInfo.sequence === sequenceId) {
            updatedProgramInfo.adBreaks = updatedProgramInfo.adBreaks.map(ad => {
                if (ad.adSqId === adSqId) {
                    const assetId = matchedFiller["id"];
                    const duration = matchedFiller["duration"];
                    const title = matchedFiller["filename"];
                    const assetType = adType;
                    const date = null;
                    
                    return {
                        ...ad,
                        assetId,
                        duration,
                        title,
                        assetType,
                        date,
                    };
                }
                return ad;
            });
        }

        // Calculate total duration from adBreaks
        const totalAdBreakDuration = updatedProgramInfo?.adBreaks?.reduce((sum, ad) => sum + (ad.duration || 0), 0) || 0;

        // Sort the adBreaks based on startOffsetInMillis or startAt and reassign adSqId
        let totalDuration = 0;
        let updatedAdBreaks = updatedProgramInfo?.adBreaks
        ?.sort((a, b) => (a.startOffsetInMillis || 0) - (b.startOffsetInMillis || 0))
        .map((ad, index) => ({
            ...ad,
            adSqId: index + 1, // Assign incremental adSqId
        }));

        updatedAdBreaks = updatedAdBreaks.map((ad, index) => {
        totalDuration += index === 0 ? 0 : updatedAdBreaks[index - 1]?.duration || 0;
        const startOffsetInMillis = ad.adInsertionPoint + totalDuration;

        return {
            ...ad,
            startOffsetInMillis,
            startAt: millisecondsToHuman(startOffsetInMillis),
        };
        });

        // Update program with adjusted totalDuration and endAt
        const updatedScheduleItem = {
        ...updatedProgramInfo,
        adBreaks: updatedAdBreaks,
        totalDuration: (updatedProgramInfo?.duration || 0) + totalAdBreakDuration,
        endAt: (updatedProgramInfo?.startAt || 0) + (updatedProgramInfo?.duration || 0) + totalAdBreakDuration, // Adjust endAt based on startAt
        };
    
        setProgramInfo(updatedScheduleItem);
    };

    const setAdsTime = (e, adSqId, sequenceId) => {
         // Check for negative value
        if (e < 0) {
            toast.error("Negative value not allowed!", {
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000
            });
            return; // Exit the function
        }
        let convertTime = verifyMilliSeconds(e? e:0);        
        let isGridEdited = false; 
        let tenantId = JSON.parse(localStorage.getItem("tenantInfo"));
        let schedule = { ...programInfo }; // Clone object
        
        if (schedule.sequence === sequenceId) {
            if (schedule.duration < convertTime) {
                toast.error("Ads cannot be set beyond the video's duration.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    autoClose: 3000
                });
                return schedule;
            }
        
            // const isOverlapping = schedule.adBreaks.some(
            //     a => a.adInsertionPoint === convertTime && a.adSqId !== adSqId
            // );
        
            // if (isOverlapping && tenantId?.code !== "shemaroo") {
            //     toast.error("Ad cannot overlap with an existing ad.", {
            //         position: toast.POSITION.BOTTOM_RIGHT,
            //         autoClose: 3000
            //     });
            //     return schedule;
            // }
            
            let totalDuration = 0;
            
            let updatedAdBreaks = schedule.adBreaks.map(ad => {
                if (ad.adSqId === adSqId) {
                    isGridEdited = true;
                    return {
                        ...ad,
                        adInsertionPoint: convertTime,
                        adInsertionPointFormat: e
                    };
                }
                return ad;
            });
        
            // Recalculate Offsets
            totalDuration = 0;
            updatedAdBreaks = updatedAdBreaks.map((ad, index) => {
                if (index > 0) {
                    totalDuration += updatedAdBreaks[index - 1]?.duration || 0;
                }
                const startOffsetInMillis = ad.adInsertionPoint + totalDuration;
        
                return {
                    ...ad,
                    startOffsetInMillis,
                    startAt: millisecondsToHuman(startOffsetInMillis),
                };
            });
        
            schedule = { ...schedule, adBreaks: updatedAdBreaks };
        }
        
        setProgramInfo(schedule);
    };

    const deleteEvent = (seqId) => {
        let isGridEdited = false;
        let updatedScheduleItems = {
            ...programInfo
        }
        // Filter and update adBreaks
        const updatedAdBreaks = updatedScheduleItems.adBreaks
            ?.filter(ad => ad.adSqId !== seqId) // Remove the ad with matching adSqId
            .map((ad, index) => ({
                ...ad,
                adSqId: index + 1 // Rearrange adSqId
            })) || [];

        // If adBreaks updated, mark grid as edited
        if (updatedAdBreaks.length !== (updatedScheduleItems.adBreaks?.length || 0)) {
            isGridEdited = true;
        }

        // Recalculate total duration, startAt, and endAt
        let totalAdBreakDuration = updatedAdBreaks.reduce((sum, ad) => sum + (ad.duration || 0), 0);
        const totalDuration = totalAdBreakDuration + (updatedScheduleItems?.duration || 0);
        const endTime = updatedScheduleItems?.startAt + (updatedScheduleItems?.duration || 0) + totalAdBreakDuration;
        const adBreaksCount = updatedAdBreaks.length;

        // Update the object
        updatedScheduleItems.adBreaks = updatedAdBreaks;
        updatedScheduleItems.totalDuration = totalDuration;
        updatedScheduleItems.adBreaksCount = adBreaksCount;
        updatedScheduleItems.endAt = endTime;
    
        setProgramInfo(updatedScheduleItems);
    };

    const addAdsOnClick = async(adType) => {
        let value = {};
        if (adType == "filler") {
            value = locationState?.state?.defaultFiller;
        } else {
            value = promoList[0];
        }
        const isEmptyObject = val =>
        val && typeof val === "object" && !Array.isArray(val) && Object.keys(val).length === 0;
        const isEmptyArray = val => Array.isArray(val) && val.length === 0;
        if (
            value == null || // null or undefined
            isEmptyArray(value) || // empty filler array
            isEmptyObject(value) // empty object
        ) {
            toast.error(`${adType} asset missing or invalid.`, {
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000,
            });
            return;
        }
        
        if (!(locationState.state.channelAssembly === "AWS")) {
            const assetValidate = await adValidate(value["id"], adType == "filler"? "AD": "PROMO");
            if (!assetValidate?.status) {
                toast.error(assetValidate?.message, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    autoClose: 3000
                });
                return;
            } 
        }
    
        // Function to check if the new ad break overlaps with existing ad breaks
        function isOverlapping(adBreaks, newAd) {
            return adBreaks.some(ad => {
                const adStart = ad.startOffsetInMillis;
                const adEnd = ad.startOffsetInMillis + ad.duration;
                const newAdStart = newAd.startOffsetInMillis;
                const newAdEnd = newAd.startOffsetInMillis + newAd.duration;
    
                const isOverlap = 
                    (newAdStart >= adStart && newAdStart < adEnd) || 
                    (newAdEnd > adStart && newAdEnd <= adEnd) || 
                    (newAdStart <= adStart && newAdEnd >= adEnd);
    
                if (isOverlap) {
                    toast.error("New Ad cannot overlap with an existing ad.", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        autoClose: 3000,
                    });
                }
                return isOverlap;
            });
        }

        let isGridEdited = false;
        const lastAdBreak = programInfo.adBreaks[programInfo.adBreaks.length - 1];  
        const lastStartOffset = lastAdBreak ? lastAdBreak?.startOffsetInMillis + lastAdBreak?.duration: 0;
        const newStartOffset = lastStartOffset; // Adjust as needed for increment
        const totalAdBreakDurations = programInfo?.adBreaks?.reduce((sum, ad) => sum + (ad.duration || 0), 0);
        const NewhoverTime = newStartOffset + verifyMilliSeconds(`${programInfo?.adBreaks.length == 0 ? "00:00:00" : "00:00:30"}`) - totalAdBreakDurations;
        
        let obj = {
            adSqId: lastAdBreak?.adSqId + 1,
            assetId: value["id"],
            type: adType,
            adInsertionPoint: NewhoverTime,
            adInsertionPointFormat: millisecondsToHuman(NewhoverTime),
            duration: value["duration"],
            startOffsetInMillis: newStartOffset,
            title: value["filename"],
            date: null,
        };    
        const isValid = !isOverlapping(programInfo.adBreaks, obj);
        if (isValid) {
            isGridEdited = true; // Mark grid as edited
        }

        let updatedProgramInfo = {
            ...programInfo, 
            adBreaks: isValid ? [...programInfo.adBreaks, obj] : programInfo.adBreaks
        }
        
        // Calculate total duration from adBreaks
        const totalAdBreakDuration = updatedProgramInfo?.adBreaks?.reduce((sum, ad) => sum + (ad.duration || 0), 0) || 0;

        // Sort the adBreaks based on startOffsetInMillis or startAt and reassign adSqId
        let totalDuration = 0;
        let updatedAdBreaks = updatedProgramInfo?.adBreaks
        ?.sort((a, b) => (a.startOffsetInMillis || 0) - (b.startOffsetInMillis || 0))
        .map((ad, index) => ({
            ...ad,
            adSqId: index + 1, // Assign incremental adSqId
        }));

        updatedAdBreaks = updatedAdBreaks.map((ad, index) => {
        totalDuration += index === 0 ? 0 : updatedAdBreaks[index - 1]?.duration || 0;
        const startOffsetInMillis = ad.adInsertionPoint + totalDuration;

        return {
            ...ad,
            startOffsetInMillis,
            startAt: millisecondsToHuman(startOffsetInMillis),
        };
        });

        // Update program with adjusted totalDuration and endAt
        const updatedScheduleItem = {
        ...updatedProgramInfo,
        adBreaks: updatedAdBreaks,
        totalDuration: (updatedProgramInfo?.duration || 0) + totalAdBreakDuration,
        endAt: (updatedProgramInfo?.startAt || 0) + (updatedProgramInfo?.duration || 0) + totalAdBreakDuration, // Adjust endAt based on startAt
        };

        setProgramInfo(updatedScheduleItem);
    };

    const blurTimeouts = useRef({});
    const latestTimeValues = useRef({});

    const handleChange = (val, adSqId) => {
        latestTimeValues.current[adSqId] = val;
    };

    const handleBlur = (adSqId, sequence, adType) => {
        // Clear existing timeout (if any)
        if (blurTimeouts.current[adSqId]) {
        clearTimeout(blurTimeouts.current[adSqId]);
        }

        // Set new timeout
        blurTimeouts.current[adSqId] = setTimeout(() => {
        const latestValue = latestTimeValues.current[adSqId];
        if (latestValue) {
            setAdsTime(latestValue, adSqId, sequence, adType);
            latestTimeValues.current[adSqId] = null;
        }
        }, 100); // Short delay
    };

    const handleFocus = (adSqId) => {
        if (blurTimeouts.current[adSqId]) {
        clearTimeout(blurTimeouts.current[adSqId]);
        }
    };

    return (
        <Modal show={show} contentClassName="rounded modalmainbody" onHide={handleClose} backdrop="static">
            <Modal.Header closeButton className='p-0 align-items-start'>
                <div className='d-flex w-100 justify-content-between'>
                    <Modal.Title style={{ color: "#FFFFFF", fontWeight: "500" }}>
                        
                        {/* | Schedule:  */}
                        <span style={{fontSize: "16px"}}>{programInfo?.scheduledDate}</span>
                        {/* at {formatTime(programInfo?.startAt)} */}
                        {/* | Duration: {millisecondsToHuman(programInfo?.totalDuration)} */}
                    </Modal.Title>
                    <div className="d-flex align-items-center">
                        {
                            !(programInfo?.published && editableTime >= programInfo?.startAt) && (
                                editDisable?
                                <span className="ads-table-btn pe-3 d-flex text-decoration-underline" style={{ fontWeight: "500" }} onClick={() => setEditDisable((prev) => !prev)}><img src={editoutline} alt="" style={{ filter: "invert(68%) sepia(26%) saturate(617%) hue-rotate(313deg) brightness(102%) contrast(96%)" }} width={16} />
                                </span>
                                :
                                <span className="ads-table-btn pe-3 d-flex text-decoration-underline pt-1" style={{ fontWeight: "500" }} onClick={(e) => {updateModalData(programInfo)}}>Update
                                </span>
                            )
                        }
                        <div onClick={handleClose} style={{ cursor: "pointer" }}>
                            <img src={closeIcon} alt="close" />
                        </div>
                    </div>
                </div>
            </Modal.Header>
            <div className="right-side-content">
                <div className="background-right-container rounded" style={{height: "100%"}}>
                    <div className={`top-content-right ${appTheme === "light"? "rounded shadow-sm": ""}`}>
                        {/* <div className="left-side">
                            <h5 className="py-3 px-3">{assetInfo?.title}</h5>
                        </div> */}
                        <div className="asset-duration-cont py-2">
                            <span
                                className="pb-1"
                                style={{
                                display: "inline-block",
                                maxWidth: "445px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                verticalAlign: "bottom",
                                fontSize: "20px",
                                color: "#FFFFFF"
                                }}
                                title={programInfo?.title}
                            >
                                {programInfo?.title}
                            </span>
                            <div className="d-flex align-items-center justify-content-between py-1">
                                <div className="start-end-time edit-timepicker-design p-0">
                                    <h5 className="d-flex mb-0 align-items-center">{
                                    programInfo?
                                    <>
                                        <TimePicker
                                            value={formatTime(programInfo?.startAt)}
                                            hourPlaceholder="HH"
                                            minutePlaceholder="mm"
                                            secondPlaceholder="ss"
                                            maxDetail="second"
                                            format="HH:mm:ss"
                                            disableClock={true}
                                            disabled={editDisable}
                                            onChange={(e) => {
                                                ignoreClickRef.current = true;
                                                setProgramTime(e, programInfo?.uuid, programInfo?.sequence, programInfo?.panelDate);
                                            }}
                                        />
                                        -
                                        <TimePicker
                                            value={formatTime(programInfo?.endAt)}
                                            hourPlaceholder="HH"
                                            minutePlaceholder="mm"
                                            secondPlaceholder="ss"
                                            maxDetail="second"
                                            format="HH:mm:ss"
                                            disableClock={true}
                                            disabled={true}
                                            style={{background: "#000"}}
                                        />
                                    </>
                                    :
                                    "00:00:00 - 00:00:00"
                                    }</h5>
                                </div>
                                <div className="d-flex video-ads-time p-0 justify-content-end">
                                    <h5 className="mx-2 mb-0 py-1 px-2 fw-normal d-flex align-items-center" style={{fontSize: ".875rem", background: "#FFFFFF1F", borderRadius: "15px"}}><span>Video</span> - {programInfo? millisecondsToHuman(programInfo?.duration) : "00:00:00"}</h5>
                                    {
                                        categoryTab === "Ads" ?
                                            <h5 className="ms-2 mb-0 py-1 px-2 fw-normal d-flex align-items-center" style={{fontSize: ".875rem", background: "#FFFFFF1F", borderRadius: "15px"}}><span>Ads</span> - 
                                                {programInfo?
                                                    millisecondsToHuman(programInfo?.adBreaks
                                                        ?.filter(data => data?.type === "ad" || data?.type === "filler")
                                                        ?.reduce((total, ad) => total + ad.duration, 0)
                                                    )
                                                    :
                                                    "00:00:00"
                                                }
                                            </h5>
                                        :
                                        categoryTab === "Promos" ?
                                            <h5 className="ms-2 mb-0 py-1 px-2 fw-normal d-flex align-items-center" style={{fontSize: ".875rem", background: "#FFFFFF1F", borderRadius: "15px"}}><span>Pro</span> - 
                                                {programInfo?
                                                    millisecondsToHuman(programInfo?.adBreaks
                                                        ?.filter(data => data?.type === "promo")
                                                        ?.reduce((total, ad) => total + ad.duration, 0)
                                                    )
                                                    :
                                                    "00:00:00"
                                                }
                                            </h5>
                                        :
                                        categoryTab === "Secondary" ? 
                                            <h5 className="ms-2 mb-0 py-1 px-2 fw-normal d-flex align-items-center" style={{fontSize: ".875rem", background: "#FFFFFF1F", borderRadius: "15px"}}><span>Sec</span> - 
                                                {programInfo?
                                                    millisecondsToHuman(programInfo?.adBreaks
                                                        ?.filter(data => data?.assetType === "FILLER")
                                                        ?.reduce((total, ad) => total + ad.durationInMillis, 0)
                                                    )
                                                    :
                                                    "00:00:00"
                                                }
                                            </h5>
                                        :
                                        ''
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`bottom-content-right ${appTheme === "light"? "rounded shadow-sm": ""}`}>
                        <div className="tabs mt-3">
                            <ul className={`channel-category-tab py-1 px-1 ${appTheme === "light" ? "border shadow-sm": ""}`}>
                                <li className={categoryTab === "Ads" ? "active" : ""}>
                                <a className='p-0' onClick={() => handlecategoryTab("Ads")} style={{height: "1.5rem"}}>Ads <span>{programInfo?.adBreaks?.filter(item => item.type === "filler")?.length || 0}</span></a>
                                </li>
                                <li className={categoryTab === "Promos" ? "active" : ""}>
                                <a className='p-0' onClick={() => handlecategoryTab("Promos")} style={{height: "1.5rem"}}>Promos <span>{programInfo?.adBreaks?.filter(item => item.type === "promo")?.length || 0}</span></a>
                                </li>
                                <li className={categoryTab === "Secondary" ? "active" : ""}>
                                <a className='p-0' disable onClick={() => {handlecategoryTab("Secondary");}} style={{height: "1.5rem"}}>Secondary</a>
                                </li>
                            </ul>
                        </div>
                        <div className={`ads-table ads-font-size mb-2 mt-3 rounded ${appTheme === "light"? "shadow-sm border" : ""}`} style={{ 
                                // height: "15rem" 
                                height: "calc(80vh - 220px)" 
                            }}>
                            <table className={`table ${appTheme === "light"? "border table-striped table-hover" : ""}`}>
                                <thead>
                                    <tr>
                                        <th>Name <span className="header-icon"></span></th>
                                        <th>Start Time <span className="header-icon"></span></th>
                                        <th>Duration</th>
                                        <th>
                                            {
                                                permission === "edit" &&
                                                "Actions"
                                            }
                                        </th>
                                    </tr>
                                </thead>
                                <tbody ref={tbodyRef} tabIndex={-1}>
                                    { categoryTab === "Ads"?
                                        programInfo?.adBreaks?.some((data) => data?.type === "ad" || data?.type === "filler")?
                                        programInfo?.adBreaks
                                            ?.filter((data) => data?.type === "ad" || data?.type === "filler")
                                            .map((data, index) => {
                                                return (
                                                    <tr key={data.id}>
                                                        <td style={{width:"40%"}}>   
                                                            <select className="p-0" value={data?.assetId} onChange={(e)=> {selectedFiller(e.target.value, data?.adSqId, programInfo?.sequence, programInfo?.panelDate, 'filler')}} disabled={editDisable} style={{ color: `${editDisable? "#6D6D6D": ""}` }}>
                                                                {
                                                                    fillerList?.map((fillers) => {
                                                                        return <option value={fillers?.id} >{fillers?.filename}</option>
                                                                    })
                                                                }
                                                            </select>
                                                        </td>
                                                        <td style={{width:"25%"}}>
                                                            <TimePicker
                                                                key={data.adSqId}
                                                                value={millisecondsToHuman(data?.adInsertionPoint)}
                                                                hourPlaceholder="HH"
                                                                minutePlaceholder="mm"
                                                                secondPlaceholder="ss"
                                                                maxDetail="second"
                                                                format="HH:mm:ss"
                                                                disableClock={true}
                                                                disabled={editDisable}
                                                                onChange={(e) => {
                                                                    setAdsTime(e, data?.adSqId, programInfo?.sequence);
                                                                }}
                                                                // onChange={(val) => handleChange(val, data.adSqId)}
                                                                // onFocus={() => handleFocus(data.adSqId)}
                                                                // onBlur={() => handleBlur(data.adSqId, programInfo?.sequence, "filler")}
                                                            />
                                                        </td>
                                                        <td style={{width:"25%"}}>
                                                            <div className="ads-duration py-1">
                                                                {millisecondsToHuman(data?.duration)}
                                                            </div>
                                                        </td>
                                                        <td style={{width:"10%"}}>
                                                            {
                                                                permission === "edit" &&
                                                                <div className="table-action-group w-75 mx-auto d-flex align-items-center justify-content-center">
                                                                    <div className='icon-group'>
                                                                        <span className="table-icon" style={{ filter: `${editDisable? "invert(0.35)" : "invert(0.75)"}`}} onClick={()=> {!editDisable && deleteEvent(data?.adSqId, programInfo?.sequence, programInfo?.panelDate)}}><img src={deleteIcon} width={15} /></span>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                            :
                                            <td colspan="4" class="text-center no-data" style={{height: "210px"}}>
                                                No ads to display.
                                            </td>
                                        :
                                        categoryTab === "Promos"?
                                        programInfo?.adBreaks?.some((data) => data?.type === "promo")?
                                        programInfo?.adBreaks
                                            ?.filter((data) => data?.type === "promo")
                                            .map((data) => {
                                                return (
                                                    <tr key={data.id}>
                                                        <td style={{width:"40%"}}>   
                                                            <select className="p-0" value={data?.assetId} onChange={(e)=> {selectedFiller(e.target.value, data?.adSqId, programInfo?.sequence, programInfo?.panelDate, "promo")}} disabled={editDisable} style={{ color: `${editDisable? "#6D6D6D": ""}` }}>
                                                                {
                                                                    promoList?.map((fillers) => {
                                                                        return <option value={fillers?.id} >{fillers?.filename}</option>
                                                                    })
                                                                }
                                                            </select>
                                                        </td>
                                                        <td style={{width:"25%"}}>
                                                            <TimePicker
                                                                key={data.adSqId}
                                                                value={millisecondsToHuman(data?.adInsertionPoint)}
                                                                hourPlaceholder="HH"
                                                                minutePlaceholder="mm"
                                                                secondPlaceholder="ss"
                                                                maxDetail="second"
                                                                format="HH:mm:ss"
                                                                disableClock={true}
                                                                disabled={editDisable}
                                                                onChange={(e) => {
                                                                    setAdsTime(e, data?.adSqId, programInfo?.sequence);
                                                                }}
                                                                // onChange={(val) => handleChange(val, data.adSqId)}
                                                                // onFocus={() => handleFocus(data.adSqId)}
                                                                // onBlur={() => handleBlur(data.adSqId, programInfo?.sequence, "promo")}
                                                            />
                                                        </td>
                                                        <td style={{width:"25%"}}>
                                                            <div className="ads-duration py-1">
                                                                {millisecondsToHuman(data?.duration)}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {
                                                                permission === "edit" &&
                                                                <div className="table-action-group w-75 mx-auto d-flex align-items-center justify-content-center">
                                                                    <div className='icon-group'>
                                                                        <span className="table-icon" style={{ filter: `${editDisable? "invert(0.35)" : "invert(0.75)"}`}} onClick={()=> {deleteEvent(data?.adSqId, programInfo?.sequence)}}><img src={deleteIcon} /></span>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                            :
                                            <td colspan="4" class="text-center no-data" style={{height: "210px"}}>
                                                No promos to display.
                                            </td>
                                        :
                                        categoryTab === "Secondary"?
                                        <td colspan="4" class="text-center no-data" style={{height: "210px"}}>
                                            No Secondary to display.
                                        </td>
                                        :
                                        ''
                                    }
                                </tbody>
                            </table>
                        </div>
                        {!editDisable && (() => {
                            const map = {
                                Ads: { label: "Ad", type: "filler" },
                                Promos: { label: "Promo", type: "promo" },
                            }[categoryTab];
                            return map ? (
                                <span
                                    className="mt-3 ads-table-btn p-2 text-decoration-underline"
                                    style={{ fontSize: "14px" }}
                                    onClick={() => addAdsOnClick(map.type)}
                                >
                                    + {map.label} Break
                                </span>
                            ) : null;
                        })()}
                    </div>
                    <div className={`bottom-container-buttons`}>
                        <div className="buttons-container mt-2 py-2 d-flex justify-content-between align-items-center">
                            {
                                !(programInfo?.published && editableTime >= programInfo?.startAt) &&
                                <a 
                                    className={`btn btn-secondary w-50 me-2 ${appTheme === "dark"? 'text-white': ''}`} 
                                    onClick={(e) => {programDelete(e, programInfo?.uuid, programInfo?.panelDate)}}
                                    style={{
                                        height: "2rem",
                                    }}
                                >Delete</a>
                            }
                            
                            {/* <button  
                                className={`btn btn-secondary w-50 mx-1 ${appTheme === "dark"? 'text-white': ''}`} 
                                onClick={(e) => {updateModalData(programInfo)}}
                                disabled={editDisable}
                                style={{
                                    height: "2rem"
                                }}
                            >Update</button> */}
                            <a 
                                className={`btn btn-danger w-50 ${(programInfo?.published && editableTime >= programInfo?.startAt) ? "me-2" : "mx-3"}`}
                                onClick={(e) => { 
                                    e.preventDefault();
                                    updateModalData(programInfo);
                                    if ((programInfo?.sequence - 1) > 0) {
                                        toGetAssetInfo(programInfo?.sequence - 1, programInfo?.panelDate);
                                        document
                                        .getElementById(`sequenceId${programInfo?.sequence - 1}`)
                                        ?.scrollIntoView({ behavior: "smooth" }); // Scroll to target section
                                    } else {
                                        const oneDayMillis = 24 * 60 * 60 * 1000;
                                        const preDayEpoch = programInfo?.panelDate - oneDayMillis;
                                        const lastItem = gridList.find((data) => data?.date === preDayEpoch);
                                        if (gridList[1]?.date <= preDayEpoch) {
                                            toGetAssetInfo(lastItem?.scheduleItems.length, preDayEpoch);
                                            document
                                            .getElementById(`sequenceId${programInfo?.sequence - 1}`)
                                            ?.scrollIntoView({ behavior: "smooth" }); // Scroll to target section
                                        }
                                    }
                                }}
                                style={{
                                    height: "2rem"
                                }}
                            >Previous</a>
                            <a 
                                className="btn btn-primary w-50 ms-2"
                                onClick={(e) => {
                                    e.preventDefault();
                                    updateModalData(programInfo);
                                    if (programInfo?.sequence < programInfo?.panelLength) {
                                        toGetAssetInfo(programInfo?.sequence + 1, programInfo?.panelDate);
                                        document
                                        .getElementById(`sequenceId${programInfo?.sequence + 1}`)
                                        ?.scrollIntoView({ behavior: "smooth" }); // Scroll to target section
                                    } else {
                                        const oneDayMillis = 24 * 60 * 60 * 1000;
                                        const nextDayEpoch = programInfo?.panelDate + oneDayMillis;
                                        toGetAssetInfo(1, nextDayEpoch);
                                        document
                                        .getElementById(`sequenceId${programInfo?.sequence + 1}`)
                                        ?.scrollIntoView({ behavior: "smooth" }); // Scroll to target section
                                    }
                                }}
                                style={{
                                    height: "2rem"
                                }}
                            >Next</a>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>

        
    )
}

export default AdsInfo;